import GLBetalingspaakrav from './Betalingspaakrav.js';
export default GLBetalingspaakrav;
//# sourceMappingURL=index.js.map